import React, {useEffect, useState} from 'react';
import {get} from '../../Model/Network/Config/Axios'
import {useLocation} from 'react-router-dom'
import Invoice from './Invoice'
import Pr from './Pr'
import Po from './Po';
import GRN from './GRN';
import Rfq from './Rfq';
import {Spinner} from '../Common/fLoader';
import Ques from './question.png'
import Contract from './Contract';
import AmendContract from './ContractAmendment';
import Boarding from './Boarding';
import Tick from "./tick.png";
import VendorAdvance from './VendorAdvance';
    function Index(props) {

    let LOCATION = useLocation()
    const PARAMS = new URLSearchParams(LOCATION.search);
    const Token = PARAMS.get('token');

    const [Type, setType] = useState(undefined);
    const [Forms, setForms] = useState([]);
    const [Po_, setPo_] = useState({});
    const [GRN_, setGRN_] = useState({});
    const [contract,setContract] = useState({});
    const [amendContract,setAmendContract] = useState({});
    const [Inputs, setInputs] = useState([]);
    const [Timeline, setTimeline] = useState([]);
    const [primaryColor,setPrimaryColor] = useState(undefined)
    const [logo,setLogo] = useState(undefined)
    const [tenant,setTenant] = useState('')
    const [vendorBoarding,setVendorBoarding] = useState(undefined)
    const [vendorAdvance,setVendorAdvance] = useState(undefined)

    useEffect(() => {
        fetchToken(Token)
    }, [Token]);

    useEffect(()=>{
        get(`company.details`,(e,r)=>{
            if(r){
                setTenant(r.code)
                setPrimaryColor(r.color);
                if(r.whiteLabel && r.whiteLabel.sidebar && r.whiteLabel.sidebar.logo) {
                    setLogo(r.whiteLabel.sidebar.logo)
                }
            }
        },{token:Token})
    },[Token])

    const fetchToken = (token) => {
            get('task.fetch',(e,r)=>{
                if(r){
                    setType(r.details.type)
                    setForms(r.forms);
                    if(r.inputs){
                        setInputs(r.inputs);
                    }
                    if(r.timelines){
                        setTimeline(r.timelines);
                    }
                    if(r.details.type==='po'){
                        setPo_(r)
                    }
                    if(r.details.type==='grn'){
                        setGRN_(r)
                    }
                    if(r.details.type==='vendor-contract'){
                        setContract(r)
                    }
                    if(r.details.type==='contract-amendment'){
                        setAmendContract(r)
                    }
                    if(r.details.type==='boarding'){
                        setVendorBoarding(r)
                    }
                    if(r.details.type==='vendor-advance'){
                        setVendorAdvance(r)
                    }
                }else{
                    // Extract error message from the error object
                    let message = 'invalid'
                    if (e && e.response && e.response.data && e.response.data.message) {
                        message = e.response.data.message;
                    } else if (e && e.message) {
                        message = e.message;
                    } else if (typeof e === 'string') {
                        message = e;
                    }
                     message = (message ===  'Task already completed') ? message : 'invalid'
                    // Set type to 'invalid' when there's an error
                    setType(message)
                }
            },{token})
       
    }

    return (<>
       {
        Type?
            (Type ==='invoice' || Type === 'utility')
            ?<Invoice logo={logo} type={Type} primaryColor={primaryColor} token={Token} form={Forms} inputs={Inputs} timelines={Timeline}/>
            : Type==='pr'
            ?<Pr logo={logo} primaryColor={primaryColor} token={Token} form={Forms} inputs={Inputs} timelines={Timeline}/>:
            Type === 'rfq' 
            ?<Rfq logo={logo} primaryColor={primaryColor} token={Token} form={Forms} inputs={Inputs} timelines={Timeline}/>
            : Type==='po'
            ?<Po logo={logo} primaryColor={primaryColor} token={Token} form={Forms} po={Po_} inputs={Inputs} timelines={Timeline}/>
            : Type==='grn'
            ?<GRN logo={logo} primaryColor={primaryColor} token={Token} form={Forms} grn={GRN_} inputs={Inputs} timelines={Timeline}/>
            : Type==='vendor-contract'?
            <Contract logo={logo} primaryColor={primaryColor} token={Token} form={Forms} contract={contract} inputs={Inputs} timelines={Timeline}/>
            :  Type==='contract-amendment'?
              <AmendContract logo={logo} primaryColor={primaryColor} token={Token} form={Forms} contract={amendContract} inputs={Inputs} timelines={Timeline}/>
            :  Type==='boarding'?
              <Boarding tenant={tenant} logo={logo} primaryColor={primaryColor} token={Token} form={Forms} boarding={vendorBoarding} inputs={Inputs} timelines={Timeline}/>
            :  Type==='vendor-advance'?
              <VendorAdvance logo={logo} primaryColor={primaryColor} token={Token} form={Forms} advance={vendorAdvance} inputs={Inputs} timelines={Timeline}/>
            :
            Type==='invalid'
            ?<div className="container cards mt-5" style={{fontSize: '14px', borderRadius: '10px', textAlign: 'center'}}>
                    <img className="img-fluid mb-4 m-auto" src={Ques} style={{maxWidth: '80px'}} alt=""/>
                    <h1 className="display-4 fw-bold">Request Failed</h1>
                    <p>{Type || 'This Request is deprecated and not available for review.'}</p>
                </div>
            : Type === 'Task already completed' ?
            <div className="container cards" style={{ fontSize: "14px", borderRadius: "10px", textAlign: "center" }}>
					<img className="m-auto mb-4 img-fluid" src={Tick} style={{ maxWidth: "80px" }} alt="" />
				    <h4 className="display-7 fw-bold">This Task Already Completed</h4>
		    	</div>
            :<></>
        :<Spinner style={{marginTop: '150px'}}/>
        }
    </>);
}

export default Index;